import React from "react";
import {
  History,
  Target,
  Rocket,
  Globe,
  Shield,
  ChevronRight,
  Cpu,
  Settings,
  Wrench,
} from "lucide-react";

const CorporateTimeline = () => {
  const milestones = [
    {
      year: "2020",
      title: "Company Foundation",
      event:
        "Focus Inspection Technology founded to provide specialized NDT inspection services for shipyard, fabrication, and industrial maintenance projects.",
      status: "Start",
      icon: <History className="w-5 h-5" />,
    },
    {
      year: "2021",
      title: "Field Expansion",
      event:
        "Operations expanded into shutdown projects, offshore inspection, welding inspection, and structural integrity testing with certified technicians.",
      status: "Growth",
      icon: <Globe className="w-5 h-5" />,
    },
    {
      year: "2022",
      title: "Advanced PAUT / TOFD",
      event:
        "Investment in advanced PAUT and TOFD inspection systems including OmniScan MX2 and X4 for pipeline, pressure vessel, and critical weld inspection.",
      status: "Technology",
      icon: <Target className="w-5 h-5" />,
    },
    {
      year: "2023",
      title: "Custom Engineering",
      event:
        "Development of in-house manual and semi-automated scanners for complex geometry inspection and special project requirements.",
      status: "Engineering",
      icon: <Settings className="w-5 h-5" />,
    },
    {
      year: "2024",
      title: "Software Development",
      event:
        "Internal development of digital reporting systems, inspection log software, and cloud-based documentation tools.",
      status: "Software",
      icon: <Cpu className="w-5 h-5" />,
    },
    {
      year: "2026",
      title: "Focus NDT Group Formation",
      event:
        "Formation of Focus NDT Group with Focus Inspection Technology and Focus NDT Innovations operating as separate divisions under one structure.",
      status: "Group",
      icon: <Shield className="w-5 h-5" />,
    },
  ];

  return (
    <section
      id="timeline"
      className="py-20 md:py-32 px-4 sm:px-6 bg-slate-50 overflow-hidden"
    >
      <div className="max-w-6xl mx-auto">

        {/* HEADER */}

        <div className="mb-16 md:mb-24">

          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-[2px] bg-orange-600"></div>
            <span className="text-orange-600 text-xs font-bold tracking-widest uppercase">
              Company Timeline
            </span>
          </div>

          <h2 className="text-3xl sm:text-4xl md:text-6xl font-black text-slate-900 leading-tight">
            Operational Milestones
          </h2>

          <p className="text-slate-500 mt-4 max-w-xl text-sm">
            From a small inspection service provider to a growing industrial
            technology group delivering NDT services, engineering solutions,
            and digital inspection software.
          </p>

        </div>


        {/* TIMELINE */}

        <div className="relative">

          {/* line */}

          <div className="absolute left-3 md:left-6 top-0 bottom-0 w-[2px] bg-slate-200" />

          <div className="space-y-10">

            {milestones.map((m, i) => (

              <div key={i} className="relative pl-10 md:pl-16">

                {/* dot */}

                <div className="absolute left-[6px] md:left-[18px] top-3 w-3 h-3 bg-white border-2 border-slate-900 rounded-full" />

                <div className="bg-white border border-slate-100 p-5 md:p-6 shadow-sm hover:shadow-md transition">

                  <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">

                    <div className="flex items-center gap-3">

                      <div className="p-2 bg-slate-100">
                        {m.icon}
                      </div>

                      <div>

                        <h4 className="font-bold text-lg">
                          {m.title}
                        </h4>

                        <span className="text-xs text-orange-600 font-bold uppercase tracking-wider">
                          {m.status}
                        </span>

                      </div>

                    </div>

                    <div className="text-2xl md:text-3xl font-black text-slate-300">
                      {m.year}
                    </div>

                  </div>

                  <p className="text-sm text-slate-500 mt-3 leading-relaxed">
                    {m.event}
                  </p>

                </div>

              </div>

            ))}

          </div>

        </div>



        {/* ASSETS */}

        <div className="mt-20 bg-slate-900 text-white p-6 md:p-10">

          <h3 className="font-bold text-lg mb-6 flex items-center gap-2">
            <Wrench className="text-orange-500" />
            Technical Assets
          </h3>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">

            <div>
              <div className="text-2xl font-black text-orange-500">
                06
              </div>
              <p className="text-xs uppercase text-white/60">
                PAUT Units
              </p>
            </div>

            <div>
              <div className="text-2xl font-black text-orange-500">
                03
              </div>
              <p className="text-xs uppercase text-white/60">
                UT Machines
              </p>
            </div>

            <div>
              <div className="text-2xl font-black text-orange-500">
                PRO
              </div>
              <p className="text-xs uppercase text-white/60">
                Scanners
              </p>
            </div>

            <div>
              <div className="text-2xl font-black text-orange-500">
                FULL
              </div>
              <p className="text-xs uppercase text-white/60">
                MT / PT Kits
              </p>
            </div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default CorporateTimeline;